import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import {
    PROCESS_LOAD_TASK,
    REGISTRATION_COMPLETE,
    TASK_ACTION_COMPLETE
} from 'processflow/actions';

export function loadCurrentTaskStep(state, action){
    if(!action || action.type !== PROCESS_LOAD_TASK){
        return state;
    }

    const result = {
        ...state
    };

    const currentStep = lodash.get(action.payload, 'me.currentTaskStep', {});
    const { task, step, content } = currentStep;

    lodash.set(result, 'processflow.current', { task, step, content: JSON.parse(content) });
    return result;
}

export function registrationComplete(state, action){
    if(!action || action.type !== REGISTRATION_COMPLETE){
        return state;
    }

    const result = {
        ...state
    };

    lodash.unset(result, 'processflow.current');
    lodash.set(result, 'processflow.complete', true);
    lodash.set(result, 'me.hasCompletedRegistration', true);

    return result;
}

export function completeTaskAction(state, action){
    if(!action || action.type !== TASK_ACTION_COMPLETE){
        return state;
    }

    const result = {
        ...state
    };

    const currentStep = lodash.get(action.payload, 'completeTaskAction', {});
    if(lodash.isEmpty(currentStep)){
        lodash.unset(result, 'processflow.current');
        lodash.set(result, 'processflow.complete', true);
        lodash.set(result, 'me.hasCompletedRegistration', true);
    }
    else {
        const { task, step, content } = currentStep;
        lodash.set(result, 'processflow.current', { task, step, content: JSON.parse(content) });
    }
    return result;
}

export default composeReducers(
    loadCurrentTaskStep,
    registrationComplete,
    completeTaskAction
);
